import { useContext } from "react";
import { uniqueId } from "lodash";
import { EditableContext } from "../../common/EditableContextProvider";
import { FormPago } from "./FormPago";
import { Modal, Table } from "antd";
const { Column } = Table;

export const TablePagos = () => {
    const { casos, pagos } = useContext(EditableContext);
    return (
        <div className="mb-2">
            <h5>Pagos</h5>
            <div className="my-1">
                Presupuesto: 
                <span className="fw-bold ms-2">
                    {casos.editItem.presupuesto??0}
                </span>
            </div>
            {
                (casos.editItem.id > 0) ? (
                    <div className="my-2">
                        <Table
                            size="small"
                            dataSource={casos.editItem.pagos}
                            rowKey="id"
                            scroll={{ y: 400, }}
                            footer={() => (<>
                                <a href="#" className="" onClick={() => pagos.newPago()}>
                                    Agregar...
                                </a>
                            </>)}
                            pagination={{ position:[] }}
                            bordered
                        >
                            <Column title="*" dataIndex="id" key="buttons" width={90} className="text-center"
                                render={(value, row) => (
                                    <>
                                        <button className="btn btn-sm btn-light border"
                                            onClick={() => pagos.selectPago(row)}
                                        >
                                            <span className="fas fa-pen"></span>
                                        </button>
                                        <button className="btn btn-sm btn-light border ms-1"
                                            onClick={() => pagos.handle_delete_pago(row)}
                                        >
                                            <span className="fas fa-trash"></span>
                                        </button>
                                    </>
                                )}
                            />
                            <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                                width={100}
                                render={(value) => sprintf('%04d', value)}
                            />
                            <Column title="Código" dataIndex="codigo" key="codigo" align="center"
                                width={100}
                            />
                            <Column title="Fecha" dataIndex="fecha" key="fecha" align="center"
                                width={100}
                            />
                            <Column title="Monto en Bs." dataIndex="monto" key="monto"
                                align="right"
                                width={100}
                            />
                            <Column title="Descripción" dataIndex="descripcion" key="descripcion"
                                width={250}
                                render={(value, row) => (
                                    <span className="fw-bold">
                                        {value}
                                    </span>
                                )}
                            />
                            <Column title="Estado" dataIndex="estado" key="estado"
                                width={200}
                                render={(value, row) => (
                                    <>
                                        <select name="estado" id="estado"
                                            className="form-select form-select-sm"
                                            value={row.estado}
                                            onChange={(e) => pagos.changeEstadoPago(row.id, e.target.value)}
                                            disabled={pagos.loadingEstado}
                                        >
                                            <option value="PENDIENTE">PENDIENTE</option>
                                            <option value="PAGADO">PAGADO</option>
                                        </select>
                                    </>
                                )}
                            />
                        </Table>

                    </div>
                ) : (<>Guarda el registro para agregar pagos.</>)
            }

            <Modal
                open={pagos.visibleFormPago}
                onCancel={pagos.closeFormPago}
                destroyOnClose={true}
                footer={null}
            >
                <FormPago />
            </Modal>
        </div>
    );
}